import styled from 'styled-components'

const LayoutGroupItemIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 5px;
  font-size: 16px;
`

export default LayoutGroupItemIcon